import React, { PureComponent } from 'react'
import { Motion, spring } from 'react-motion';
import WindowScrollSink from './WindowScrollSink'


const MotionScroll = ({ scrollLeft , el}) => {
  return (
    <Motion style={{ scrollLeft: spring(scrollLeft) }}>
      {interpolatingStyle => {
        return (
          <WindowScrollSink scrollLeft={interpolatingStyle.scrollLeft} el={el}/>
        )
      }}
    </Motion>
  )
}

export default MotionScroll;



// WEBPACK FOOTER //
// ./src/views/HomeView/MotionScroll.js